import React, { useState } from "react";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { IWizardManager } from "./GenericWizardStore";
import { logDebug } from "../common/logger";

export interface IWizardStepProps {
	onNext: (next: number) => void;
	onBack: () => void;
	onCancel: () => void;
	manager: IWizardManager;
}

// TODO :: make more generic
const GenericWizardRightBar: React.FC<{ manager: IWizardManager; steps: React.ComponentType<IWizardStepProps>[] }> = observer(
	({ manager, steps }) => {
		const onCancel = () => {
			manager.onWizardCancel();
		};
		const onNext = (next: number) => {
			manager.onWizardNext(next);
		};
		const onBack = () => {
			manager.onWizardBack();
		};
		useEffect(() => {
			manager.initWizard();
			if (!manager) {
				// this is for tool specific wizard
				// // TODO :: this is quite a mess. Do something about it
				// const selectedTupple = mappingStore.templateData!.rows[mappingToolStore.selectedTuple[0]].cellTuples[mappingToolStore.selectedTuple[1]];
				// mappingToolStore.setCurrentTupple(selectedTupple);
			}
		}, []);

		// logDebug('manager.wizardStep', manager.wizardStep, steps[manager.wizardStep - 1]);
		const StepComponent = steps[manager.wizardStep - 1];
		return (
			<div className="flex w-full h-full bg-white flex-col justify-between items-start inline-flex ">
				<div className="w-full h-full ">
					{StepComponent && <StepComponent onCancel={onCancel} onNext={onNext} onBack={onBack} manager={manager} />}
				</div>
				<div className="cursor-pointer absolute right-6 top-4 bg-white">
					<img
						src="/assets/ui/x-close.svg"
						className="w-5 h-5"
						onClick={() => {
							const result = window.confirm("Are you sure you want to close? You will lose all unsaved data.");
							if (result) {
								onCancel();
							}
						}}
					/>
				</div>
			</div>
		);
	}
);

export default GenericWizardRightBar;
